var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-input"},[_c('InputWithSelect',{attrs:{"options":_vm.types,"text-value":_vm.spec[_vm.type],"label":_vm.label,"placeholder":_vm.placeholder},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }